import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const addVendorMasterQuery = (data) => axios.post(apiurl?.addVendorMaster, data);

const addVendorMaster = () => {
  const queryClient = useQueryClient();
  return useMutation(addVendorMasterQuery, {
    onSuccess: () => {
      queryClient.invalidateQueries('getvendorlist');
    }
  });
};

export default addVendorMaster;
